import Cascader from './Cascader';
export default Cascader;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-cascader/src/index.js